import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient, Session } from '@benzinga/session';
import { GetReportResponse, GetReportDataResponse } from '../entities';
import { StockReportsEnvironment } from '../environment';

export class StockReportsRestful extends RestfulClient {
  constructor(sessionManager: Session) {
    super(sessionManager.getEnvironment(StockReportsEnvironment).url, sessionManager);
  }

  getReport = (ticker: string, email: string): SafePromise<GetReportResponse> => {
    const url = this.URL(`v1/report/pdf?ticker=${ticker}&email=${email}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };

  getReportData = (ticker: string): SafePromise<GetReportDataResponse> => {
    const url = this.URL(`v1/report/data?ticker=${ticker}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
